import { ErrorMessage, useField } from "formik";
import React, { useCallback } from "react";
import { Form } from "react-bootstrap";

export const NumberFormGroup: React.FC<{
  fieldName: string;
  fieldDisplayName: string;
  placeholder?: string;
  error?: string;
  value?: number;
  disabled: boolean;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T_1 = string | React.ChangeEvent<any>>(
      field: T_1
    ): T_1 extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  className?: string;
}> = (props) => {
  const [, , helpers] = useField(props.fieldName);
  const innerHandleChange = useCallback((e: React.ChangeEvent<any>) => {
    const val = e.target.value;
    helpers.setValue(val == "" ? undefined : val);
  }, []);
  return (
    <Form.Group className={props.className}>
      <Form.Label>{props.fieldDisplayName}</Form.Label>
      <Form.Control
        isInvalid={props.error != null}
        name={props.fieldName}
        placeholder={props.placeholder}
        value={props.value ?? ""}
        disabled={props.disabled}
        onChange={innerHandleChange}
      />
      <ErrorMessage
        name={props.fieldName}
        component={Form.Text}
        className="text-danger"
      />
    </Form.Group>
  );
};
